<h5 class="titulo">Faixas de carteira pessoa jurídica</h5>

<div class="container">
  <div class="row">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>

    <div class="col-auto">
      <button class="btn btn-primary no-margin" type="button" [routerLink]="['/faixa-carteira-pessoa-juridica/cadastro']"
        ngbTooltip="Tela para cadastro de Faixa de carteira PJ "><i class="fa fa-file-signature">
        </i> Cadastrar nova Faixa
      </button>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

    <div class="col-auto">
      <button #focusableSubmit type="button" class="btn btn-success no-margin" (click)="buscaFaixasCarteira(true)">
        Pesquisar
      </button>
    </div>
  </div>

  <div class="row">

    <div class="bn-form-group col-md-6">
        <label>Agente Financeiro:</label>
        <ng-select
          [(ngModel)]="agenteFinanceiro"
          id="agenteFinanceiro"
          [items]="agentesFinanceiros"
          bindLabel="nome"
          bindValue="cnpj"
          placeholder="Todos"
          class="auto-grow">
          <ng-template ng-label-tmp let-item="item">
            {{ item.nome }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" container="body">
            {{ item.nome + ' (' + item.cnpj + ')' }}
          </ng-template>
        </ng-select>
    </div>
    <div class="bn-form-group col-md-3">
      <label>Apenas agentes habilitados:</label>
      <input type="checkbox" class="form-check checkbox-gigante" name="aceitaModalidadeInvestimento" (change)="mostraAgentesDesabilitados()"
        [(ngModel)]="agentesHabilitados">
    </div>
    <div class="bn-form-group col-md-3">
      <label>Situação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Exibe a situação da Faixa de Carteira do Agente Financeiro."></i></label>
        <select id="situacao" class="form-select" [(ngModel)]="situacao">
          <option [ngValue]="undefined" selected>Todos</option>
          <option ngValue="ATIVO">Ativo</option>
          <option ngValue="INATIVO">Inativo</option>
        </select>
    </div>

  </div>

  <div class="row">

    <div class="bn-form-group col-md-6">
      <label for="tranche">Cesta: </label>
        <select id="tranche" class="form-select" [(ngModel)]="idTranche" disabled>
          <option [ngValue]="null"></option>
          <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
            {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
    </div>

    <div class="bn-form-group col-md-6">
      <label>Faixa <i class="fas fa-ellipsis-v " style="cursor: pointer;color: #0078c0;" [ngbPopover]="tipContent" placement="bottom" autoClose="outside"></i></label>
        <select id="numeroFaixa" class="form-select" [(ngModel)]="numeroFaixa">
          <option [ngValue]="undefined" selected></option>
          <option *ngFor="let valor of valoresFaixaCarteira" [ngValue]="valor.numeroFaixa">{{ valor.labelFaixa }}</option>
        </select>
    </div>
  </div>
</div>

<ng-template #tipContent>
  <div>
    <div>
      Modalidade PEAC: As faixas são utilizadas no cálculo da distribuição de limites e ativação do AF.
      <p><p>
      Modalidade FG-SEBRAE: As faixas são utilizadas no cálculo do valor do limite de exposição do AF.
    </div>
  </div>
</ng-template>

<app-faixa-carteira-pessoa-juridica-listagem
  [faixasCarteira]="faixasCarteira" *ngIf="pesquisado" [hidden]="esconderPesquisa"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarFaixas)="exportar($event)">
</app-faixa-carteira-pessoa-juridica-listagem>
